import { render, staticRenderFns } from "./EditFeeForm.vue?vue&type=template&id=12320ca1&scoped=true&"
import script from "./EditFeeForm.vue?vue&type=script&lang=js&"
export * from "./EditFeeForm.vue?vue&type=script&lang=js&"
import style0 from "./EditFeeForm.vue?vue&type=style&index=0&id=12320ca1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12320ca1",
  null
  
)

export default component.exports